module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_tribe-186c6112e7d5e1cdf54fbd915386ead5.svg";